import localhost from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";

import {
  appendWorkspaceDocuments,
  resetWorkspaceDocuments,
  setIsLastPage,
  setIsLoading,
  setIsLoadingMore,
  setPageNumber,
  setWorkspaceDocuments,
} from "./workspaceV2Slice";

const DEFAULT_PAGE_SIZE = 50;

export const fetchWorkspaceDocuments =
  ({
    reset = false,
    search = "",
    pageNumber = 0,
    pageSize = DEFAULT_PAGE_SIZE,
    sortColumn = "name",
    sortOrder = "ASC",
    entityType,
    entityId,
  } = {}) =>
  async (dispatch) => {
    if (reset) {
      dispatch(resetWorkspaceDocuments());
    }

    const isFirstPage = reset || pageNumber === 0;
    if (isFirstPage) {
      dispatch(setIsLoading(true));
    } else {
      dispatch(setIsLoadingMore(true));
    }

    try {
      const rsp = await localhost.get("/nextgen/workspace/documents", {
        params: { search, pageNumber, pageSize, sortColumn, sortOrder, entityType, entityId },
      });
      const data = rsp?.data || [];

      if (isFirstPage) {
        dispatch(setWorkspaceDocuments(data));
      } else {
        dispatch(appendWorkspaceDocuments(data));
      }

      dispatch(setIsLastPage(data.length < pageSize));
      dispatch(setPageNumber(pageNumber));
    } catch (error) {
      dispatch(showErrorModal(error));
    } finally {
      dispatch(setIsLoading(false));
      dispatch(setIsLoadingMore(false));
    }
  };
